// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "mp-property-filter-menu{display:inline-flex}:host{display:inline-flex}.mp-property-filter-menu{position:relative}.mp-property-filter-menu mp-properties-menu{max-height:$drop-menu-max-height}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
